
<template>
  <BaseDelete
    :entry="entry"
    @delete-confirm-action="destroyEntry"
    deleteTitle="Deleção de condições comercias"
    :formErrors="formErrors"
    ref="baseDelete"
  >
    <p> Você tem certeza que deseja deletar esta condição comercial ?</p>
  </BaseDelete>
</template>

<script>
import gql from 'graphql-tag';
import BaseDelete from "@components/shared/base_delete.vue";

export default {
  data () {
    return {
      error: null,
      loading: true,
      formErrors: []
    }
  },
  components: {
    BaseDelete: BaseDelete
  },
  props: {
    entry: Object,
  },
  methods: {
    destroyServerEntry: function(table_price_item) {
      this.loading = true;
        this.$apollo
          .mutate({
            mutation: DESTROY_TABLE_PRICE_ITEM_MUTATION,
            variables: {
              id: table_price_item.id,
            }
          })
          .then(response => {
            var errors = response.data.destroyTablePriceItem.errors
            if (errors.length){
              this.formErrors = errors
            } else {
              this.$emit("entry-destroyed");
              this.$refs.baseDelete.closeDialog();
            }
          })
          .catch(response => console.log(response))
          .finally(() => (this.loading = false));
    },
    destroyEntry: function() {
      this.destroyServerEntry(this.entry);
    },
  }
}
const DESTROY_TABLE_PRICE_ITEM_MUTATION = gql `
  mutation($id: ID!) {
    destroyTablePriceItem(id: $id) {
      tablePriceItem {
        id
      }
      errors
    }
  }
`;
</script>

<style scoped></style>

